module.exports = __webpack_public_path__ + "static/media/single-portfolio-2.d48fc906.jpg";